module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 24
// module chunks = 0